import {etatsDesPav} from './etat.js';

// F7 : alertes à date, indépendantes de la période choisie. Seul le parc ACTIF est concerné.

const MS_JOUR = 86400000;

export function joursEntre(a, b) {
    const [ya, ma, da] = a.split('-').map(Number);
    const [yb, mb, db] = b.split('-').map(Number);
    return Math.round((Date.UTC(yb, mb - 1, db) - Date.UTC(ya, ma - 1, da)) / MS_JOUR);
}

// `pavs` (optionnel) : sous-ensemble de PAV à considérer (filtre circuits du dashboard) ; absent = tout le parc actif.
export function alertes(index, aujourdhui, {pavs = null} = {}) {
    const actifs = (pavs || index.pavs).filter((p) => p.statut !== 'RETIRÉ');

    // Lavage impossible 2 fois de suite : les deux derniers passages de lavage (LAVAGE / IMPOSSIBLE, par date puis heure)
    // sont tous deux IMPOSSIBLE. Les autres types d'événements sont ignorés.
    const impossiblesIds = [];
    const parMotif = new Map();
    for (const pav of actifs) {
        const passages = (index.evenementsParPav.get(pav.id) || [])
            .filter((e) => (e.type === 'LAVAGE' || e.type === 'IMPOSSIBLE') && e.date <= aujourdhui)
            .sort((x, y) => (x.date + (x.heure || '')).localeCompare(y.date + (y.heure || '')));
        if (passages.length < 2) continue;
        const [avant, dernier] = passages.slice(-2);
        if (avant.type !== 'IMPOSSIBLE' || dernier.type !== 'IMPOSSIBLE') continue;
        impossiblesIds.push(pav.id);
        for (const m of dernier.motifs || []) parMotif.set(m, (parMotif.get(m) || 0) + 1);
    }
    let motifN1 = null;
    for (const [libelle, nb] of parMotif) {
        if (motifN1 === null || nb > motifN1.nb || (nb === motifN1.nb && libelle.localeCompare(motifN1.libelle) < 0)) motifN1 = {libelle, nb};
    }

    const etatsMaint = etatsDesPav(index, {acte: 'maint', du: '', au: aujourdhui, at: aujourdhui});
    const etatsLavage = etatsDesPav(index, {acte: 'lavage', du: '', au: aujourdhui, at: aujourdhui});

    const defautIds = [];
    const parElement = new Map();
    const condamneesIds = [];
    for (const pav of actifs) {
        const maint = etatsMaint.get(pav.id);
        if (maint.verdict === 'pb') {
            defautIds.push(pav.id);
            for (const libelle of maint.elementsEnDefaut) parElement.set(libelle, (parElement.get(libelle) || 0) + 1);
        }
        if (etatsLavage.get(pav.id).verdict === 'imp') condamneesIds.push(pav.id);
    }

    let elementN1 = null;
    for (const [libelle, nb] of parElement) {
        if (elementN1 === null || nb > elementN1.nb || (nb === elementN1.nb && libelle.localeCompare(elementN1.libelle) < 0)) {
            elementN1 = {libelle, nb};
        }
    }

    return {
        impossiblesConsecutifs: {nb: impossiblesIds.length, pavIds: impossiblesIds, motifN1},
        enDefautMaintenance: {nb: defautIds.length, pavIds: defautIds, elementN1},
        signalementsOuverts: null, // non raccordé
        condamnees: {nb: condamneesIds.length, pavIds: condamneesIds},
    };
}
